import { Action, ActionReducer } from '@ngrx/store';
import { StatusFilterAction, StatusFilterActionType } from '../../actionstypes/selected-id/status-filter.actiontype';

const initialState = '';

const statusFilterReducer = (state = initialState, action: StatusFilterActionType): string => {
  switch (action.type) {
    case StatusFilterAction.Set:
      return action.payload;

    case StatusFilterAction.Reset:
      return '';

    case StatusFilterAction.Sync:
      if (state === '') {
        return state;
      }

      if (!action.payload.includes(state)) {
        return '';
      }

      return state;

    default:
      return state;
  }
};

export default statusFilterReducer as ActionReducer<string, Action<string>>;
